(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7301],{

/***/ 81601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var ContactUs = function ContactUs(_ref) {
  var isPaymentGuideline = _ref.isPaymentGuideline,
      isRefundPolicy = _ref.isRefundPolicy;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(common_contexts__WEBPACK_IMPORTED_MODULE_1__/* .LayoutContext */ .VY),
      locationRouter = _useContext.locationRouter;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("section", {
      id: "contact-us",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          text: "Contact Us",
          className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800"
        }), isRefundPolicy ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "mb-6",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
            className: "mb-4",
            children: "Should you have any queries regarding service quality and refund requests, please email us via: compliance@bbcincorp.com. We will do our best to support you with your queries."
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
            children: "You can also contact us at the following address:"
          })]
        }) : locationRouter !== "sg" && locationRouter !== "hk" && !isPaymentGuideline && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          className: "mb-6 lg:mb-10",
          children: "If you have any questions about this Agreement, please contact us by email or regular mail at the following address:"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "".concat(locationRouter === "sg" || locationRouter === "hk" ? "lg:grid-cols-1" : "lg:grid-cols-2", "  grid gap-y-6 lg:gap-x-[30px] lg:gap-y-0"),
          children: [locationRouter !== "sg" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "grid h-full gap-y-4 rounded-md bg-white px-4 py-6 shadow-[0px_9px_24px_rgba(196,196,196,0.25)] lg:grid-rows-[auto_52px_1fr_auto_auto] lg:px-6",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              text: "BBCIncorp Limited in Hong Kong",
              className: "text-2xl font-semibold leading-9 text-bbc-brand-700"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
              children: ["Registered No: 2508698", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "D-U-N-S Number 664611652."]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex auto-rows-auto items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/location-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "https://goo.gl/maps/adod2kPo4Ht2GXXH9",
                rel: "nofollow noreferrer",
                target: "_blank",
                children: "Room 9, 4F, Beverley Commercial Centre, 87-105 Chatham Road South, Tsim Sha Tsui, Kowloon, Hong Kong"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/earth-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "mailto:service@bbcincorp.com",
                rel: "nofollow",
                children: "service@bbcincorp.com"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/phone-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "tel:+85281928666",
                rel: "nofollow",
                children: "(+852) 8192 8666"
              })]
            })]
          }), locationRouter !== "hk" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "grid h-full gap-y-4 rounded-md bg-white px-4 py-6 shadow-[0px_9px_24px_rgba(196,196,196,0.25)] lg:grid-rows-[auto_52px_1fr_auto_auto] lg:px-6",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              text: "BBCIncorp Pte. Ltd. in Singapore",
              className: "text-2xl font-semibold leading-9 text-bbc-brand-700"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
              className: "".concat(locationRouter === "sg" || locationRouter === "hk" ? "hidden" : "hidden lg:block")
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/location-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                children: "68 Circular Road, #02-01 Singapore (049422), Singapore"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/earth-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "mailto:service@bbcincorp.com",
                rel: "nofollow",
                children: "service@bbcincorp.com"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/phone-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "tel:+6531381666",
                rel: "nofollow",
                children: "(+65) 3138 1666"
              })]
            })]
          })]
        })]
      })
    })
  });
};

ContactUs.defaultProps = {
  isPaymentGuideline: false,
  isRefundPolicy: false
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactUs);

/***/ }),

/***/ 82254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69156);
/* harmony import */ var components_organisms_Banner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47447);
/* harmony import */ var components_organisms_ContactUs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81601);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var Component = function Component(_ref) {
  var dataJson = _ref.dataJson;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_organisms_Banner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      minHeightBanner: "banner-min-h-569",
      breadcrumbs: dataJson.breadcrumbs,
      title: "Order Process",
      titleProps: {
        className: "banner-default-title mb-6 lg:mb-10 capitalize",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/images/common/".concat(dataJson.banner_image),
        wrapper: {
          className: "bbc-banner-image-country"
        },
        className: "w-full",
        width: 622,
        height: 400,
        priority: true,
        alt: "banner-img"
      }),
      bgColor: "bg-bbc-useful-links"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "container mt-10 lg:mt-20",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          data: dataJson.dataOrderProcess.map(function (item, index) {
            return _objectSpread(_objectSpread({}, item), {}, {
              name: "<span class='font-semibold text-md text-bbc-brand-700'>".concat(index + 1, ".\n                ").concat(item.name, "\n                </span>")
            });
          }),
          buttonClass: "!pl-0",
          panelClass: "!pl-0"
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_organisms_ContactUs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 77540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/order-process/index.js
var order_process = __webpack_require__(82254);
;// CONCATENATED MODULE: ./pages/vn/order-process/data.json
var data_namespaceObject = JSON.parse('{"country":"Hong Kong","banner_image":"order-process.png","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Order Process ","uri":"/order-process"}],"dataOrderProcess":[{"name":"Consulting","content":"<p>Offshore company is a type of favored company to attain information security, retain business secrets, limited responsibility and tax-free. All information we provide is totally legal, and you can conduct international trade all over the world. There are only some options created for optimizing your business like which is the structure, where is the best jurisdiction/ bank, how about the tax scheme,... Come to us and give us some pieces of information, you can get the solutions. We consult via mobile/ email/ skype before you decide to order your company.</p>"},{"name":"Ordering","content":"<p>Forming an IBC:</p><p>If You have chosen a IBC, you can easily order it by using our online Order Command. The Order form is quite simple, and it contains explanations and comments along the way. Please note that completing and submitting our online Order Form does not oblige or bind you to anything &ndash; it merely serves as your first signal to us, allowing us to assess your requirements and see how we can deal with them.</p><p>If you do not wish to send your order information over internet, please download the Order form from our download section, complete and sign before send it to us by email, fax or by regular mail/ courier.</p><p>Note: Payment will be done by visa or master card, or stripe on the final step.</p>"},{"name":"Our Feedback","content":"<p>Upon receipt of your company formation order, we will review it, and come back to you. After receive your order and your payment, one of our customer relationship manager (CRM) will contact you directly on telephone/ skype/ email as the method you want to confirm the order. Please make sure to include precise contact details with your order &ndash; if we can`t contact you, we will refund the fee(s) and can\'t proceed any further!</p><p>Depending on the required structure of the new company there may be some additional questions to be clarified. We will also confirm to you if the required company name is available. When all details of your order are clear and confirmed by you, we will issue a precise and itemized proforma invoice automatically with your Customer ID.</p>"},{"name":"Due diligence and Client Information","content":"<p>As required by the law and by the conditions of our Corporate Service Providers License, we must properly identify and know our client and the beneficial owner(s) of the new company. This requirement is uniformly accepted throughout the offshore financial services industry and all reputable company formation agents are bound by it. Therefore, before proceeding with a new incorporation for any new clients, we need to receive a couple of documents that identify and characterize the clients we are dealing with - like, a certified copy of passport, a proof of address, etc. We will advise you what exactly is required and how to prepare this paperwork in the easiest possible way (scan copy via email or fax).</p><p>If you are a professional organization (intermediary) which intends to purchase companies regularly for resale, specific due diligence requirements will apply &ndash; please inquire for full details.</p><p>Please rest assured that all of the information you provide to us will be kept in total confidentiality. It is for our internal file only and will remain there! The client information never appears on any public record or registrar (unless the client especially says so) and stiff criminal penalties will be enforced upon us if we illegally divulge our client information to anyone.</p>"},{"name":"Registration","content":"<p>Upon confirmation of all details of your order, receipt of the due diligence information and receipt of payment, we will prepare the Memorandum of Association, the Articles of Association and other mandatory documents required to register your IBC. There is no need for you to sign any incorporation documents for an International Business Company &ndash; the initial company formation paperwork is prepared and signed on Your behalf by the Registered Agent (us), as prescribed by the International Business Companies Act 1994. For a Special License Company, however, you would have to prepare and sign several documents/forms and send those over to us by scan via email/ fax.</p><p>We will pay the applicable capital duties and registration fees. Then the documents will be filed to the Jurisdiction&rsquo;s Registrar of Companies. In order to comply with the minimum local presence requirements in registration, we will also provide the Registered Address and Agent for your new company.</p>"},{"name":"Incorporation documents","content":"<p>After few of working weeks (depend on jurisdiction), the set of corporate documents for a International Business Company or a Special Company will always include the standard logical sequence of documentation:</p><ol><li>Original Certificate of Incorporation;</li><li>Certified copies of Memorandum &amp; Articles of Association;</li><li>Original signed Memorandum of the Registered agent appointing the First Director(s);</li><li>Original Instrument of Transfer (if any);</li><li>First Board Resolutions;</li><li>Letter(s) of Consent to act as Director;</li><li>Application(s) for allotment of shares;</li><li>Share Certificates;</li><li>Register of Directors;</li><li>Register of Secretaries;</li><li>Register of Members;</li><li>A set of blank registers and share certificates for your future use (if any);</li><li>Company seal in digital and a Company&rsquo;s kit.</li></ol><p>If we have been ordered to provide nominee director or nominee shareholder service to the company, additional documentation may include share transfer forms or trust declarations, powers of attorney, additional corporate resolutions and other documentation.</p>"},{"name":"Certification","content":"<p>In most cases your company documents will probably need to be certified. Documents issued in one country would usually be acceptable only within that one country only. A document can be certified by a Notary or by a government officer &ndash; for example, by the Registrar of Companies &ndash; but this is still a purely local certification.</p><p>To make a document legally acceptable abroad, most countries in the world have agreed on a uniform system of 2nd level certification of public documents. This is the so-called Apostille legalization, or The Hague Convention 1961 process.</p><p>By this procedure, the signature and powers of the person who has done the initial local certification (say, a Notary or Attorney) are then additionally confirmed by a 2nd level certification stamp. This stamp or sticker is called Apostille. It is usually issued by a designated government office, often by Foreign Office or the Supreme Court.</p><p>After this 2nd level certification the document would be generally acceptable as legal in all member countries of the Hague Convention. That&rsquo;s most of the countries of the world. For a full list of all countries members of the Hague Convention please look here. If your country happens not to be in the list, you may need your documents to be legalized in the respective embassy. This is long, cumbersome and expensive, but usually can be done.</p><p>Why would you need that additional certification by Apostille?</p><p>If you intend to open a foreign bank or securities account for your offshore company, to purchase a real estate in the name of your offshore company, to register a branch or a joint venture with your offshore company, or to enter into any similar deal where you would have to show the company documents to a third party outside jurisdiction &ndash; you will most probably be asked that the documents be properly certified by Apostille.</p><p>For these purposes, but only if confirmed in the Order, we would usually arrange Apostille certification for one full set of copies of all primary sequence of incorporation documents. Additional sets can be arranged as and when required. To be on the safe side, a separate legalization of the original Certificate of Incorporation is available, same as for any other separate document.</p><p>Any specific requests as to the form, contents and certification of the corporate documents can be completed in due course at your request, so that the configuration of your IBC is exactly as you want it to be.</p>"},{"name":"Banking","content":"<p>Depend on how your business’s cash flow run, which kind of business, how much for every transaction and how much revenue a month,… we will give you the best bank for your business. After consulting, we will need your trading proofs/ business plan as our listed to review/ arrange before bring it to bank’s review. The meeting (if any) will be held with bank as your appropriate time. In some special case, may be there is a specialist from us come to bank meeting with you to make all things fluent.</p>"},{"name":"Timing","content":"<p>From the time of order, the incorporation of an International Business Company normally takes around 2 &ndash; 5 business days (depend on each jurisdiction) to have a scan of Certificate of Incorporation.</p><p>The full process to finish an full kit of documents with corporate seal can take several weeks (about 3 weeks) or longer, and is primarily dependent on the speed at which the client can provide the information/documents required by the licensing Application.</p><p>Additional certification (Notary and Apostille) may take another 2 to 4 business days, the exact timing depends on the workload of the relevant certification offices &ndash; and this is something we cannot really control.<br />And the time for banking will take 2 weeks to 2 months depend bank\'s approval.</p>"},{"name":"Shipping","content":"<p>The documents of your offshore company will be shipped to your indicated address by airmail or courier, depending on your instructions. We use DHL courier service for all our deliveries, but other companies (Fedex or UPS) can be involved if you so wish. The courier delivery of documents may take from two up to five days worldwide, depending on destination.</p><p>Although it will be a lot cheaper, we do not really recommend delivery of documents by regular airmail. It is not too reliable and we will not be able to give you any timing estimates or guarantees that the package will even reach you. As opposed to courier delivery, you can`t track your airmail over the internet.</p>"},{"name":"Annual maintaining","content":"<p>All IBC companies must pay annual renewal fees (IBCs, pay these fees include to tax) to the Government. In addition to those, annual service fees are payable for the Registered Agent, Address services, Management Service and other additional service (as may have been ordered).</p><p>The annual professional fees to the Registered Agent are also accounted on a yearly basis and their due date for reference purposes is the registration anniversary date of the Company. For practical reasons, the annual Government fees and annual professional fees are usually raised in one invoice.</p><p>We follow up the due time for companies in our database and we would contact you approximately one months before the next anniversary of your company. We will then ask you to confirm that the operation of your company should continue for the next year. If yes, an invoice will be generated and sent to you in account for the government annual renewal fee and for the provision of the Registered Address and Agent services and other regular services that may have been ordered at incorporation. The annual renewal fees are all identified in our Fees section.</p><p>The Customer ID and password is also mentioned on the first notice email by us, you can make payment online by logging in and take payment on our website. After payment of the renewal fees we will take care of the renewal formalities for your company. If required, we will also obtain the Certificate of Good Standing for Your Company (additional fee).</p><p>The Jurisdiction&rsquo;s Government only accept the annual license fees from the Registered Agent of the particular Company. Therefore, unfortunately, clients are precluded from paying the Government fees directly.</p><p>(!) Important! The annual renewal fees MUST be paid on time. Non-payment of annual renewal fees will make the company lose its status of good standing, and the company will also incur severe late penalties and legal consequences, and will ultimately be struck-off the Registrar for being in default of its obligations.</p><p>A Company, which is struck-off the Registrar shall remain liable to any due and unpaid fees. It also remains liable to all its obligations and debts. Such company may not continue to trade or enter into any new transactions whatsoever, and its directors, shareholders and managers are by law precluded from any operations or transactions with the assets of the Company. Striking-off a Company means essentially that all its assets and funds are legally frozen until the Company is restored in good standing &ndash; or legally dissolved. In certain circumstances the owners of the Company may become personally liable with all their private assets for debts or obligations of the defaulted company.</p><p>Late payment for annual licence fees is accepted, but this will involve late penalty fees, depending on the number of days after the due date. Approximate rate of penalty fee will apply for late payment straight after the due date (depend on late time and rule of each country). It is possible to restore a company after it has been struck off the Registrar, but a substantial fee will apply depending on the number of days after strike-off. Company reinstatement also involves substantial professional fees, which may largely exceed the Government late penalty fees.</p>"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/vn/order-process/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "vn",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(order_process/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 5544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn/order-process",
      function () {
        return __webpack_require__(77540);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _stylesheetRegistry = __webpack_require__(28122);

var _hash = __webpack_require__(39035);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;

function JSXStyle(props) {
  var registry = (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27884)


/***/ }),

/***/ 51423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _construct; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(36129);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

/***/ }),

/***/ 49711:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(16988);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,4090,9738,7447,9156,9774,2888,179], function() { return __webpack_exec__(5544); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);